import axios from "axios";

// Consulta de CEP (ViaCEP) compartilhada entre os fluxos que pedem endereço.
// Vivia em PlanAndPayment/BillingDataSection; veio para cá quando o wizard de
// Nova nota (JusCont) passou a precisar do mesmo lookup.
// CadastroV2/api.js e Cadastro/index.js ainda têm cópias próprias.

export type CepAddressData = {
  address: string;
  district: string;
  city: string;
  state: string;
};

export type CepLookupResult =
  | { success: true; data: CepAddressData; fallback?: false }
  | { success: true; fallback: true; data?: undefined }
  | { success: false; error: string };

export async function searchAddressByCep(
  code: string,
): Promise<CepLookupResult> {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CEP_API_BASE_URL}/${code}/json/`,
      { timeout: 5000 },
    );
    const data = response.data;

    if (data.erro === true || data.erro === "true") {
      return {
        success: false,
        error: "Não foi possível localizar o CEP",
      };
    }

    return {
      success: true,
      data: {
        address: data.logradouro || "",
        district: data.bairro || "",
        city: data.localidade || "",
        state: data.uf || "",
      },
    };
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      (error.code === "ECONNABORTED" || error.response?.status === 502)
    ) {
      return { success: true, fallback: true };
    }

    return {
      success: false,
      error: "Não foi possível localizar o CEP",
    };
  }
}
